/* Full screen scrolling lightbox.

   Replaces the theme's PhotoSwipe zoom with a plain full screen overlay:
   every product image stacked in a scrolling column, honouring the same
   Paired images setting as the gallery, with a single close control.

   PhotoSwipe is not removed — it is simply never reached. We intercept the
   click in the capture phase and stop it before the theme's handler runs. */
(function () {
  if (window.__pdpLightboxInit) return;
  window.__pdpLightboxInit = true;

  var cfg = window.__pdpLightbox || {};
  var images = cfg.images || [];
  if (!images.length) return;

  var pairs = {};
  (cfg.pairs || []).forEach(function (n) { pairs[parseInt(n, 10)] = true; });

  var overlay = null;
  var lastFocus = null;

  function build() {
    var el = document.createElement('div');
    el.className = 'pdp-lb';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Product images');

    var close = document.createElement('button');
    close.className = 'pdp-lb__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true"><path d="M2 2 L20 20 M20 2 L2 20" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
    close.addEventListener('click', hide);

    var grid = document.createElement('div');
    grid.className = 'pdp-lb__grid';

    images.forEach(function (src, i) {
      var fig = document.createElement('figure');
      fig.className = 'pdp-lb__item' + (pairs[i + 1] ? ' pdp-lb__item--pair' : '');
      fig.setAttribute('data-index', String(i));
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = i < 2 ? 'eager' : 'lazy';
      fig.appendChild(img);
      grid.appendChild(fig);
    });

    el.appendChild(close);
    el.appendChild(grid);
    document.body.appendChild(el);
    return el;
  }

  function show(index) {
    if (!overlay) overlay = build();
    lastFocus = document.activeElement;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    overlay.classList.add('is-open');

    var target = overlay.querySelector('[data-index="' + (index || 0) + '"]');
    if (target) overlay.scrollTop = target.offsetTop;
    else overlay.scrollTop = 0;

    var btn = overlay.querySelector('.pdp-lb__close');
    if (btn) btn.focus();
  }

  function hide() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Intercept before the theme's zoom handler. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.pdp-lb')) return;

    var hit = t.closest('.splide--product .cursor-zoom-in, .splide--product .splide__slide img');
    if (!hit) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var slide = t.closest('.splide__slide');
    var idx = 0;
    if (slide) {
      var all = [].slice.call(document.querySelectorAll('.splide--product .splide__slide'));
      idx = Math.max(0, all.indexOf(slide));
    }
    show(idx);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) hide();
  });
})();
